import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import AppButton from "@/components/buttons/AppButton";
import NoDataAvailable from "@/components/cards/NoDataAvailable";
import { AssignmentListPageSkeleton } from "@/components/skeletons";
import { getUserById } from "@/services/user.service";
import { BUTTONS } from "@/utils/constants/appConstants/commonConstants";
import { useFeaturePermission } from "@/utils/hooks/useFeaturePermission";
import { NO_ROLE_ASSIGNED } from "@/utils/constants/messages";
import { getUserId } from "@/utils/functions/TokenFunction";
import { FEATURE_PERMISSIONS } from "@/utils/constants/featurePermissions";

const UserRole = () => {
    const params = useParams();
    const navigate = useNavigate();
    const id = params.id || "";
    const currentUserId = getUserId();
    const [userDetails, setUserDetails] = useState<any>({});
    const [isLoading, setIsLoading] = useState(true);
    useEffect(() => {
        setIsLoading(true);
        getUserById(
            id,
            (response: any) => {
                setIsLoading(false);
                setUserDetails(response.data);
            },
            (error: any) => {
                setIsLoading(false);
                console.log(error);
            }
        );
    }, [id]);
    /**
     * RBAC BEGIN
     */
    const isUpdateUserPermission = useFeaturePermission(FEATURE_PERMISSIONS.AdminPortalUpdateUser);
    /**
     * RBAC END
     */
    if (isLoading) {
        return <AssignmentListPageSkeleton sectionTitle="Roles" />;
    }

    return (
        <>
            <div className="mb-4 flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between">
                <h3 className="min-w-0 text-xl font-normal leading-snug text-secondary" id='user-role-email-address'>{userDetails?.email_address}</h3>
                {isUpdateUserPermission && !!userDetails && currentUserId !== userDetails?.id && (
                    <AppButton
                        id='user-role-edit-btn'
                        onClick={() => navigate(`/user/${userDetails?.id}/roles/update`)}
                        btnText={BUTTONS.EDIT}
                        className="btn-primary"
                        isLoading={false}
                    />
                )}
            </div>
            <h5 className="mb-3 mt-5 text-base font-medium" id='user-role-title'>Roles</h5>
            <div className="gs-list-page-card">
                <ul className="gs-detail-list gs-assignment-name-list">
                    {userDetails?.organizations ? (
                        userDetails.organizations[0].roles.map((role: any, key: string) => (
                            <li className="gs-detail-list-item" key={key}>
                                <div className="gs-detail-list-name" id={`user-role-name-${key}`}>{role.name}</div>
                            </li>
                        ))
                    ) : (
                        <li className="gs-detail-list-item">
                            <NoDataAvailable><p id='no-user-role-assigned'>{NO_ROLE_ASSIGNED}</p></NoDataAvailable>
                        </li>
                    )}
                </ul>
            </div>
        </>
    );
};

export default UserRole;
